import React, { PureComponent } from "react";
import FormCore from "@/components/display/form/formCore";
import ScGridTable from "@/components/display/table/gridTableCore";
import PropTypes from "prop-types";
import { getStubInfoList } from "@/fetch/fetchApi";
// 国际化切换语言
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
// 样式
import "./index.styl";

// eslint-disable-next-line arrow-parens
@connect((state) => state)
class EquipmentList extends PureComponent {
  constructor(props) {
    super(props);
    this.props = props;
  }

  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  componentWillMount() {
    this.init();
  }

  init() {
    this.formConfig = {
      childItems: [
        {
          type: "input",
          placeholder: "电站名称", // '电站名称',,
          param: {
            name: "stubGroupName",
            type: "string",
          },
          labelName: "电站名称", // '电站名称:',
          required: false,
        },
        {
          type: "input",
          placeholder: "设备编号", // '电站名称',,
          param: {
            name: "stubId",
            type: "string",
          },
          labelName: "设备编号", // '电站名称:',
          required: false,
        },
        {
          type: "buttonGp", // 表单最终执行组
          buttonArr: [
            {
              btnType: "submit",
              // icon: 'search',
              text: "查询", // '查询'
            },
          ],
        },
      ],
      layout: "inline", // 设置布局 0： 横向布局， 1：纵向布局
      formTarget: "grid", // 表单提交类型，设置grid则为更新grid
      autoLoadGrid: true, // 设置为false不触发加载grid
      context: this,
      tableKey: "diagnosticEquipmentTable",
    };
    this.setState({
      tableConfig: {
        tableKey: "diagnosticEquipmentTable",
        tableColumns: [
          {
            name: "设备编号", // '电站名称',
            key: "key",
            colType: "textCol",
            align: "center",
          },
          {
            name: "所属电站", // '电站名称',
            key: "stubGroupName",
            colType: "tipCol",
            align: "center",
          },
          {
            name: "地区", // '地区',,
            key: "cityName",
            align: "center",
            colType: "textCol",
          },
          {
            name: "操作",
            key: "action",
            colType: "action", // 操作列，可定义多种操作。
            actionMap: [
              {
                type: "href",
                actionName: "检测",
                handler: (res) => {
                  this.props.onSelect({
                    type: 1,
                    info: res,
                  });
                },
              },
            ],
          },
        ],
        tableChange: () => {},
        tableParam: {
          pagecount: 10,
        },
        dataApi: getStubInfoList,
        autoRefresh: false, // 设置为true 直接加载grid数据
      },
    });
  }

  render() {
    const Content = (
      <div className="sc-page-content">
        <div className="page-toolbar">
          <FormCore formConfig={this.formConfig} />
        </div>
        <div className="page-panel overScroll">
          <ScGridTable config={this.state.tableConfig} />
        </div>
      </div>
    );

    return Content;
  }
}

export default injectIntl(EquipmentList);



// WEBPACK FOOTER //
// ./src/AntD/pages/diagnosticManage/diagnosticAnalysis/equipmentList.js